import React from "react";

import classNames from "classnames";
import { FormattedMessage } from "gatsby-plugin-react-intl";
import PropTypes from "prop-types";
import Form from "react-bootstrap/Form";

import { ReactComponent as IconError18 } from "../../../icons/icon/18/a-icon-error-18.svg";

import "./textareaFormField.scss";

const TextareaFormField = ({
  errors,
  id,
  label,
  maxLength = Number.MAX_SAFE_INTEGER,
  meta = null,
  onBlur,
  onChange,
  placeholder = undefined,
  touched,
  values,
}) => (
  <>
    <Form.Group
      controlId={id}
      className={classNames(
        { required: meta.requiredFields.includes(id) },
      )}
    >
      <Form.Control
        as="textarea"
        label={label}
        placeholder={placeholder}
        rows={4}
        maxLength={maxLength}
        onChange={onChange}
        onBlur={onBlur}
        isInvalid={(errors[id] && touched[id])}
      />
      <Form.Label>
        {label}
      </Form.Label>
      <Form.Text className={classNames("hint", { "invalid-feedback": (errors[id] && touched[id]) })}>
        {errors[id] && touched[id]
          ? <div><IconError18 />{errors[id]}</div>
          : <div>{!meta.requiredFields.includes(id) && <FormattedMessage id="form.optional" />}</div>}
        {maxLength && !errors[id] && <div>{`${values[id].length}/${maxLength}`}</div>}
      </Form.Text>
    </Form.Group>
  </>
);

TextareaFormField.propTypes = {
  errors: PropTypes.oneOfType([PropTypes.object]).isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  maxLength: PropTypes.number,
  meta: PropTypes.oneOfType([PropTypes.object]),
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  touched: PropTypes.oneOfType([PropTypes.object]).isRequired,
  values: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default TextareaFormField;
